import React, { useRef, useState, useEffect } from 'react';
import { useInView } from 'framer-motion';
import './Hero.css';
import RotatingText from '../animation/RotatingText';

const Hero = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false, margin: '-20% 0px' });
  const [key, setKey] = useState(0);

  useEffect(() => {
    if (isInView) {
      setKey(prev => prev + 1); 
    }
  }, [isInView]);

  return (
    <section className="hero-wrapper" id="home" ref={ref}>
      <div className="hero-center">
        <h1 key={`jackie-${key}`} className="tracking-letter">
          {[...'Jackie'].map((char, i) => (
            <span key={i} style={{ animationDelay: `${i * 100}ms` }}>
              {char}
            </span>
          ))}
        </h1>

        <RotatingText
          texts={[
            'designer  •  engineer',
            'dreamer  •  tinkerer',
            'creator  •  architect',
          ]}
          mainClassName="rotator-combined"
          staggerFrom="last"
          initial={{ y: '100%', opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: '-100%', opacity: 0 }}
          staggerDuration={0.02}
          splitLevelClassName="rotator-line"
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          rotationInterval={3000}
          loop={true}
          auto={true}
          animatePresenceInitial={true}
        />
      </div>
    </section>
  );
};

export default Hero;
